import React, { useState } from 'react'
import { MapPin, Phone, Mail, Clock, Send } from 'lucide-react'
import toast from 'react-hot-toast'

const ContactPage = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    company: '',
    message: ''
  })

  const handleSubmit = (e) => {
    e.preventDefault()
    toast.success('Mesajınız alındı! En kısa sürede size dönüş yapacağız.')
    setFormData({ name: '', email: '', phone: '', company: '', message: '' })
  }

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value })
  }

  return (
    <div data-component-path="client/src/pages/ContactPage.jsx" data-component-line="1:1" data-component-id="client/src/pages/ContactPage.jsx:1:1" className="min-h-screen">
      <section data-component-path="client/src/pages/ContactPage.jsx" data-component-line="2:2" data-component-id="client/src/pages/ContactPage.jsx:2:2" 
        className="relative h-96 bg-cover bg-center flex items-center"
        style={{
          backgroundImage: 'url(https://images.unsplash.com/photo-1423666639041-f56000c27a9a?w=1600&q=80)'
        }}
      >
        <div data-component-path="client/src/pages/ContactPage.jsx" data-component-line="3:3" data-component-id="client/src/pages/ContactPage.jsx:3:3" className="absolute inset-0 bg-blue-900/70"></div>
        <div data-component-path="client/src/pages/ContactPage.jsx" data-component-line="4:4" data-component-id="client/src/pages/ContactPage.jsx:4:4" className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-white">
          <h1 data-component-path="client/src/pages/ContactPage.jsx" data-component-line="5:5" data-component-id="client/src/pages/ContactPage.jsx:5:5" className="text-5xl font-bold mb-4">İletişim</h1>
          <p data-component-path="client/src/pages/ContactPage.jsx" data-component-line="6:6" data-component-id="client/src/pages/ContactPage.jsx:6:6" className="text-xl">Size nasıl yardımcı olabiliriz?</p>
        </div>
      </section>

      <section data-component-path="client/src/pages/ContactPage.jsx" data-component-line="7:7" data-component-id="client/src/pages/ContactPage.jsx:7:7" className="py-20 bg-white">
        <div data-component-path="client/src/pages/ContactPage.jsx" data-component-line="8:8" data-component-id="client/src/pages/ContactPage.jsx:8:8" className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div data-component-path="client/src/pages/ContactPage.jsx" data-component-line="9:9" data-component-id="client/src/pages/ContactPage.jsx:9:9" className="grid grid-cols-1 lg:grid-cols-2 gap-12">
            <div data-component-path="client/src/pages/ContactPage.jsx" data-component-line="10:10" data-component-id="client/src/pages/ContactPage.jsx:10:10">
              <h2 data-component-path="client/src/pages/ContactPage.jsx" data-component-line="11:11" data-component-id="client/src/pages/ContactPage.jsx:11:11" className="text-3xl font-bold text-gray-900 mb-8">Bize Ulaşın</h2>
              
              <div data-component-path="client/src/pages/ContactPage.jsx" data-component-line="12:12" data-component-id="client/src/pages/ContactPage.jsx:12:12" className="space-y-6">
                <div data-component-path="client/src/pages/ContactPage.jsx" data-component-line="13:13" data-component-id="client/src/pages/ContactPage.jsx:13:13" className="flex items-start gap-4">
                  <div data-component-path="client/src/pages/ContactPage.jsx" data-component-line="14:14" data-component-id="client/src/pages/ContactPage.jsx:14:14" className="flex-shrink-0 w-12 h-12 bg-blue-100 rounded-lg flex items-center justify-center">
                    <MapPin className="w-6 h-6 text-blue-600" />
                  </div>
                  <div data-component-path="client/src/pages/ContactPage.jsx" data-component-line="15:15" data-component-id="client/src/pages/ContactPage.jsx:15:15">
                    <h3 data-component-path="client/src/pages/ContactPage.jsx" data-component-line="16:16" data-component-id="client/src/pages/ContactPage.jsx:16:16" className="font-semibold text-gray-900 mb-1">Adres</h3>
                    <p data-component-path="client/src/pages/ContactPage.jsx" data-component-line="17:17" data-component-id="client/src/pages/ContactPage.jsx:17:17" className="text-gray-600">
                      Dilovası Organize Sanayi Bölgesi, 1. Kısım,<br />
                      D-1003 Sokak, No: 4, P.K. 41455<br />
                      Dilovası / Kocaeli / Türkiye
                    </p>
                  </div>
                </div>

                <div data-component-path="client/src/pages/ContactPage.jsx" data-component-line="18:18" data-component-id="client/src/pages/ContactPage.jsx:18:18" className="flex items-start gap-4">
                  <div data-component-path="client/src/pages/ContactPage.jsx" data-component-line="19:19" data-component-id="client/src/pages/ContactPage.jsx:19:19" className="flex-shrink-0 w-12 h-12 bg-blue-100 rounded-lg flex items-center justify-center">
                    <Phone className="w-6 h-6 text-blue-600" />
                  </div>
                  <div data-component-path="client/src/pages/ContactPage.jsx" data-component-line="20:20" data-component-id="client/src/pages/ContactPage.jsx:20:20">
                    <h3 data-component-path="client/src/pages/ContactPage.jsx" data-component-line="21:21" data-component-id="client/src/pages/ContactPage.jsx:21:21" className="font-semibold text-gray-900 mb-1">Telefon</h3>
                    <a data-component-path="client/src/pages/ContactPage.jsx" data-component-line="22:22" data-component-id="client/src/pages/ContactPage.jsx:22:22" href="tel:+902627545238" className="text-gray-600 hover:text-blue-600">
                      +90 262 754 52 38
                    </a>
                  </div>
                </div>

                <div data-component-path="client/src/pages/ContactPage.jsx" data-component-line="23:23" data-component-id="client/src/pages/ContactPage.jsx:23:23" className="flex items-start gap-4">
                  <div data-component-path="client/src/pages/ContactPage.jsx" data-component-line="24:24" data-component-id="client/src/pages/ContactPage.jsx:24:24" className="flex-shrink-0 w-12 h-12 bg-blue-100 rounded-lg flex items-center justify-center">
                    <Mail className="w-6 h-6 text-blue-600" />
                  </div>
                  <div data-component-path="client/src/pages/ContactPage.jsx" data-component-line="25:25" data-component-id="client/src/pages/ContactPage.jsx:25:25">
                    <h3 data-component-path="client/src/pages/ContactPage.jsx" data-component-line="26:26" data-component-id="client/src/pages/ContactPage.jsx:26:26" className="font-semibold text-gray-900 mb-1">E-posta</h3>
                    <a data-component-path="client/src/pages/ContactPage.jsx" data-component-line="27:27" data-component-id="client/src/pages/ContactPage.jsx:27:27" href="mailto:admin@eminisambalaj.info" className="text-gray-600 hover:text-blue-600">
                      admin@eminisambalaj.info
                    </a>
                  </div>
                </div>

                <div data-component-path="client/src/pages/ContactPage.jsx" data-component-line="28:28" data-component-id="client/src/pages/ContactPage.jsx:28:28" className="flex items-start gap-4">
                  <div data-component-path="client/src/pages/ContactPage.jsx" data-component-line="29:29" data-component-id="client/src/pages/ContactPage.jsx:29:29" className="flex-shrink-0 w-12 h-12 bg-blue-100 rounded-lg flex items-center justify-center">
                    <Clock className="w-6 h-6 text-blue-600" />
                  </div>
                  <div data-component-path="client/src/pages/ContactPage.jsx" data-component-line="30:30" data-component-id="client/src/pages/ContactPage.jsx:30:30">
                    <h3 data-component-path="client/src/pages/ContactPage.jsx" data-component-line="31:31" data-component-id="client/src/pages/ContactPage.jsx:31:31" className="font-semibold text-gray-900 mb-1">Çalışma Saatleri</h3>
                    <p data-component-path="client/src/pages/ContactPage.jsx" data-component-line="32:32" data-component-id="client/src/pages/ContactPage.jsx:32:32" className="text-gray-600">
                      Pazartesi - Cuma: 08:00 - 17:30<br />
                      Cumartesi - Pazar: Kapalı
                    </p>
                  </div>
                </div>
              </div>

              <div data-component-path="client/src/pages/ContactPage.jsx" data-component-line="33:33" data-component-id="client/src/pages/ContactPage.jsx:33:33" className="mt-8">
                <iframe data-component-path="client/src/pages/ContactPage.jsx" data-component-line="34:34" data-component-id="client/src/pages/ContactPage.jsx:34:34"
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3016.8899999999994!2d29.5!3d40.8!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zNDDCsDQ4JzAwLjAiTiAyOcKwMzAnMDAuMCJF!5e0!3m2!1str!2str!4v1234567890"
                  width="100%"
                  height="300"
                  style={{ border: 0 }}
                  allowFullScreen=""
                  loading="lazy"
                  className="rounded-lg shadow-md"
                ></iframe>
              </div>
            </div>

            <div data-component-path="client/src/pages/ContactPage.jsx" data-component-line="35:35" data-component-id="client/src/pages/ContactPage.jsx:35:35" className="bg-gray-50 rounded-2xl p-8">
              <h2 data-component-path="client/src/pages/ContactPage.jsx" data-component-line="36:36" data-component-id="client/src/pages/ContactPage.jsx:36:36" className="text-3xl font-bold text-gray-900 mb-6">Teklif Formu</h2>
              <form data-component-path="client/src/pages/ContactPage.jsx" data-component-line="37:37" data-component-id="client/src/pages/ContactPage.jsx:37:37" onSubmit={handleSubmit} className="space-y-6">
                <div data-component-path="client/src/pages/ContactPage.jsx" data-component-line="38:38" data-component-id="client/src/pages/ContactPage.jsx:38:38">
                  <label data-component-path="client/src/pages/ContactPage.jsx" data-component-line="39:39" data-component-id="client/src/pages/ContactPage.jsx:39:39" className="block text-sm font-medium text-gray-700 mb-2">
                    Ad Soyad *
                  </label>
                  <input data-component-path="client/src/pages/ContactPage.jsx" data-component-line="40:40" data-component-id="client/src/pages/ContactPage.jsx:40:40"
                    type="text"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    required
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                  />
                </div>

                <div data-component-path="client/src/pages/ContactPage.jsx" data-component-line="41:41" data-component-id="client/src/pages/ContactPage.jsx:41:41">
                  <label data-component-path="client/src/pages/ContactPage.jsx" data-component-line="42:42" data-component-id="client/src/pages/ContactPage.jsx:42:42" className="block text-sm font-medium text-gray-700 mb-2">
                    E-posta *
                  </label>
                  <input data-component-path="client/src/pages/ContactPage.jsx" data-component-line="43:43" data-component-id="client/src/pages/ContactPage.jsx:43:43"
                    type="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    required
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                  />
                </div>

                <div data-component-path="client/src/pages/ContactPage.jsx" data-component-line="44:44" data-component-id="client/src/pages/ContactPage.jsx:44:44">
                  <label data-component-path="client/src/pages/ContactPage.jsx" data-component-line="45:45" data-component-id="client/src/pages/ContactPage.jsx:45:45" className="block text-sm font-medium text-gray-700 mb-2">
                    Telefon *
                  </label>
                  <input data-component-path="client/src/pages/ContactPage.jsx" data-component-line="46:46" data-component-id="client/src/pages/ContactPage.jsx:46:46"
                    type="tel"
                    name="phone"
                    value={formData.phone}
                    onChange={handleChange}
                    required
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                  />
                </div>

                <div data-component-path="client/src/pages/ContactPage.jsx" data-component-line="47:47" data-component-id="client/src/pages/ContactPage.jsx:47:47">
                  <label data-component-path="client/src/pages/ContactPage.jsx" data-component-line="48:48" data-component-id="client/src/pages/ContactPage.jsx:48:48" className="block text-sm font-medium text-gray-700 mb-2">
                    Firma Adı
                  </label>
                  <input data-component-path="client/src/pages/ContactPage.jsx" data-component-line="49:49" data-component-id="client/src/pages/ContactPage.jsx:49:49"
                    type="text"
                    name="company"
                    value={formData.company}
                    onChange={handleChange}
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                  />
                </div>

                <div data-component-path="client/src/pages/ContactPage.jsx" data-component-line="50:50" data-component-id="client/src/pages/ContactPage.jsx:50:50">
                  <label data-component-path="client/src/pages/ContactPage.jsx" data-component-line="51:51" data-component-id="client/src/pages/ContactPage.jsx:51:51" className="block text-sm font-medium text-gray-700 mb-2">
                    Mesajınız *
                  </label>
                  <textarea data-component-path="client/src/pages/ContactPage.jsx" data-component-line="52:52" data-component-id="client/src/pages/ContactPage.jsx:52:52"
                    name="message"
                    value={formData.message}
                    onChange={handleChange}
                    required
                    rows="5"
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent resize-none"
                  ></textarea>
                </div>

                <button data-component-path="client/src/pages/ContactPage.jsx" data-component-line="53:53" data-component-id="client/src/pages/ContactPage.jsx:53:53"
                  type="submit"
                  className="w-full h-14 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors font-semibold flex items-center justify-center gap-2 shadow-md hover:shadow-lg"
                >
                  <Send className="w-5 h-5" />
                  Gönder
                </button>
              </form>
            </div>
          </div>
        </div>
      </section>
    </div>
  )
}

export default ContactPage